export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_CLIENT_PORTALS':
      return action.payload
    default:
      return state
  }
}
